var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            inline: "",
            "label-width": "110px",
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.areaGroupIdName"),
                        prop: "upIdList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        ref: "cascader",
                        staticStyle: { width: "720px" },
                        attrs: {
                          clearable: "",
                          options: _vm.options,
                          "change-on-select": "",
                          props: _vm.propstree,
                          disabled: _vm.keyValue > 0
                        },
                        on: { change: _vm.getNode },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.buildingName"),
                        prop: "buildingName"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", type: "text" },
                        model: {
                          value: _vm.childData.buildingName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "buildingName", $$v)
                          },
                          expression: "childData.buildingName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", type: "text" },
                        model: {
                          value: _vm.childData.buildingOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "buildingOrder", $$v)
                          },
                          expression: "childData.buildingOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.buildingFloor") } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", min: 0 },
                        model: {
                          value: _vm.childData.buildingFloors,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "buildingFloors", $$v)
                          },
                          expression: "childData.buildingFloors"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.buildingType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择类型" },
                          model: {
                            value: _vm.childData.buildingType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "buildingType", $$v)
                            },
                            expression: "childData.buildingType"
                          }
                        },
                        _vm._l(_vm.typeOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              clearable: "",
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            },
                            on: { change: _vm.changeTypeValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.buildingUse") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择用途" },
                          model: {
                            value: _vm.childData.buildingUse,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "buildingUse", $$v)
                            },
                            expression: "childData.buildingUse"
                          }
                        },
                        _vm._l(_vm.useOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              clearable: "",
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            },
                            on: { change: _vm.changeUseValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.orientation") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: { placeholder: "请选择朝向" },
                          model: {
                            value: _vm.childData.buildingToward,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "buildingToward", $$v)
                            },
                            expression: "childData.buildingToward"
                          }
                        },
                        _vm._l(_vm.towardOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              clearable: "",
                              label: item.dicName,
                              value: item.dicValue
                            },
                            on: { change: _vm.changeTowardValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "经度" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { readonly: "", clearable: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.dialogRecordVisible = true
                          }
                        },
                        model: {
                          value: _vm.childData.lng,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "lng", $$v)
                          },
                          expression: "childData.lng"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "纬度" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { readonly: "", clearable: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.dialogRecordVisible = true
                          }
                        },
                        model: {
                          value: _vm.childData.lat,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "lat", $$v)
                          },
                          expression: "childData.lat"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "地址全称" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "720px" },
                        attrs: { clearable: "", placeholder: "请输入地址全称" },
                        model: {
                          value: _vm.childData.dzqc,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "dzqc", $$v)
                          },
                          expression: "childData.dzqc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "720px" },
                        attrs: {
                          clearable: "",
                          maxlength: "100",
                          type: "textarea",
                          placeholder: "请输入备注",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.buildingRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "buildingRemark", $$v)
                          },
                          expression: "childData.buildingRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择经纬度",
            visible: _vm.dialogRecordVisible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogRecordVisible = $event
            }
          }
        },
        [
          _c("selectPosition", {
            attrs: {
              coordinate: _vm.coordinate,
              "show-dialog": _vm.dialogRecordVisible
            },
            on: {
              transmitCoordinate: _vm.receiveCoordinate,
              handCancle: _vm.handleInnerCancle
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }